import { Button, Col, DatePicker, Input, InputNumber, Row, Select, Upload } from "antd";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import UploadField from "../UploadField";
import { UploadOutlined } from "@ant-design/icons";
import Error from "./Error";
import TextArea from "antd/es/input/TextArea";
import { useEffect } from "react";
import { set } from "date-fns";
import dayjs from "dayjs";
const Costing = ({ ocfDisplayId, bookingFormFields, removeBookingForm, addBookingForm }) => {
  const {
    control,
    formState: { errors },
    setValue,
    watch,
  } = useFormContext();

  const property = useWatch({ control, name: "property" });


  useEffect(() => {
    const num = (val) => parseFloat(val) || 0;

    // 1. Total BSP : (BSP + PLC) * size
    const bsp = num(property?.bsp);
    const plc = num(property?.plc);
    const size = num(property?.size);
    const totalBsp = (bsp + plc) * size;
    // 2. Property Price
    const bspGst = num(property?.bspGst);
    const otherCharges = num(property?.otherCharges);
    const otherChargesGst = num(property?.otherChargesGst);

    const bspPrice = totalBsp + totalBsp * bspGst * 0.01;
    const otherChargesPrice = otherCharges + otherCharges * otherChargesGst * 0.01;

    const propertyPrice = bspPrice + otherChargesPrice;

    // 3. Slab (Commission)
    let slab = 0;
    const revValue = num(property?.commission);

    if (property?.commissionType == "percentage") {
      slab = totalBsp * revValue * 0.01;
    } else {
      slab = revValue * size;
    }
    // 4. Discount
    let discount = 0;
    const isDiscount = property?.isDiscount;
    const discValue = num(property?.discount);

    if (property?.commissionType == "percentage") {
      discount = totalBsp * discValue * 0.01;
    } else {
      discount = discValue * size;
    }

    // 5. Net Revenue
    const netRevenue = slab - discount;

    // Update Form Values
    setValue("costing.totalBsp", totalBsp);
    setValue("costing.propertyPrice", Math.ceil(propertyPrice));
    setValue("costing.totalCommission", Math.round(slab));
    setValue("costing.totalDiscount", discount);
    setValue("costing.netRevenue", Math.round(netRevenue));
  }, [property, setValue]);
  const colProps = { xs: 24, sm: 12, md: 12, lg: 8 };
  return (
    <Row gutter={[16, 16]} style={{ margin: "28px 0" }}>
      <Col span={12} {...colProps}>
        <label>Total BSP</label>
        
        <Controller
          name="costing.totalBsp"
          control={control}
          render={({ field }) => (
            <InputNumber
              {...field}
              status={errors.totalBsp && "error"}
              style={{ width: "100%" }}
              formatter={(value) =>
                value ? `₹ ${new Intl.NumberFormat("en-IN").format(value)}` : ""
              }
              parser={(value) => (value ? value.replace(/₹\s?|(,*)/g, "") : "")}
            />
          )}
          disabled
        />
        <Error name="costing.totalBsp" />
      </Col>

      <Col span={12} {...colProps}>
        <label>Property Price</label>
        <Controller
          name="costing.propertyPrice"
          control={control}
          render={({ field }) => (
            <InputNumber
              {...field}
              style={{ width: "100%" }}
              formatter={(value) =>
                value ? `₹ ${new Intl.NumberFormat("en-IN").format(value)}` : ""
              }
              parser={(value) => (value ? value.replace(/₹\s?|(,*)/g, "") : "")}
            />
          )}
          // render={({ field }) => <Input {...field} status={errors.price && "error"} />}
          disabled
        />
        <Error name="price" />
      </Col>

      {/* Commission Value */}
      <Col span={8} {...colProps}>
        <label>Slab</label>
        <Controller
          name="costing.totalCommission"
          control={control}
          render={({ field }) => (
            <InputNumber
              {...field}
              status={errors?.commission?.value && "error"}
              style={{ width: "100%" }}
              formatter={(value) =>
                value ? `₹ ${new Intl.NumberFormat("en-IN").format(value)}` : ""
              }
              parser={(value) => (value ? value.replace(/₹\s?|(,*)/g, "") : "")}
            />
          )}
          disabled
        />
        <Error name="costing.totalCommission" />
      </Col>

      <Col span={8} {...colProps}>
        <label>Disount</label>
        <Controller
          name="costing.totalDiscount"
          control={control}
          render={({ field }) => (
            <InputNumber
              {...field}
              status={errors.commissionDiscount && "error"}
              style={{ width: "100%" }}
              formatter={(value) =>
                value ? `₹ ${new Intl.NumberFormat("en-IN").format(value)}` : ""
              }
              parser={(value) => (value ? value.replace(/₹\s?|(,*)/g, "") : "")}
            />
          )}
          disabled
        />
        <Error name="costing.totalDiscount" />
      </Col>

      <Col span={8} {...colProps}>
        <label> Net Revenue</label>
        <Controller
          name="costing.netRevenue"
          control={control}
          render={({ field }) => (
            <InputNumber
              {...field}
              status={errors.netIncome && "error"}
              style={{ width: "100%" }}
              formatter={(value) =>
                value ? `₹ ${new Intl.NumberFormat("en-IN").format(value)}` : ""
              }
              parser={(value) => (value ? value.replace(/₹\s?|(,*)/g, "") : "")}
            />
          )}
          disabled
        />
        <Error name="costing.netRevenue" />
      </Col>

      {/* <Col span={8} {...colProps}>
        <div className="form-field">
          <label className="form-label">Booking Form</label>
          <UploadField
            name="costing.bookingForm"
            fieldType="bookingForm"
            label="Upload Booking Form"
            ocfDisplayId={ocfDisplayId}
          />
          <Error name="costing.bookingForm" />
        </div>
      </Col> */}

      <Col span={8} {...colProps}>
        <label> Remark</label>
        <Controller
          name="costing.salesPersonRemark"
          control={control}
          render={({ field }) => <TextArea {...field} status={errors.netIncome && "error"} />}
        />
        <Error name="costing.salesPersonRemark" />
      </Col>
      <Row gutter={[16, 16]}>
        {errors?.costing?.bookingForm?.message && (
          <Col span={24}>
            <p style={{ color: "#ff4d4f", fontSize: 12 }}>{errors.costing.bookingForm.message}</p>
          </Col>
        )}

        {bookingFormFields.map((item, index) => (
          <Col
            key={item.id}
            xs={24} // mobile → full width
            sm={24}
            md={12} // tablet → 2 per row
            lg={8} // desktop → 3 per row
          >
            {/* <label>Booking Form #{index + 1}</label> */}

            <UploadField
              name={`costing.bookingForm.${index}.file`}
              fieldType={`bookingForm_${index + 1}`}
              label="Upload Booking Form"
              ocfDisplayId={ocfDisplayId}
            />

            <Error name={`costing.bookingForm.${index}.file`} />

            {index > 0 && !watch(`costing.bookingForm.${index}.file`)?.message && (
              <Button danger onClick={() => removeBookingForm(index)}>
                Remove
              </Button>
            )}
          </Col>
        ))}

        {/* Add Button Full Width */}
        <Col xs={24}>
          <Button type="primary" onClick={() => addBookingForm({ file: null })}>
            + Add Booking Form
          </Button>
        </Col>
      </Row>
    </Row>
  );
};

export default Costing;
